import { escape } from "lodash-es";
import { fadeInOutDuration } from "./variables";
type Course = {
  id: number;
  course: {
    id: number;
    name: string;
    needed_time: number | undefined;
    badge_id: 0;
    created_at: Date;
    update_at: Date;
    simple_description: string;
    detail_description: string;
    url_name: string;
    image_file_name: string | undefined;
    image_content_type: string | undefined;
    image_file_size: number | undefined;
    image_updated_at: Date | undefined;
    lessons_count: number;
  };
  course_image: string;
};

type Category = {
  id: number;
  short_description: string;
  description: string;
  name: string;
  created_at: Date;
  update_at: Date;
};

type filteredCategory = {
  category: Category;
  courses: Course[];
  total_time: number;
  lessons_count: number[];
};

type tag = {
  id: number;
  name: string;
  tag_group_id: number;
  created_at: Date;
  updated_at: Date;
  description: string;
};

type TagFilterAPIResponse = {
  status: string;
  message: string;
  filtered_categories: filteredCategory[];
  tags: tag[];
  courses_num: string;
};
let oldTagsSnapShot: string[];
let tags: string[];

$(() => {
  // 一覧のタグがクリックされた時
  $(".tag").click((event) => {
    // 処理を共通化するために、元々あるタグか、クリックされて生成されtタグかをBoolで渡す
    $(event.currentTarget).toggleClass("isSelected");
    tagFilter(createTagsList()).catch(() => {
      $(event.currentTarget).toggleClass("isSelected"); //AJax失敗時セレクト解除
    });
  });
  // 現在選択中のタグがクリックされた時
  $(document).on("click", ".current-tag", (event) => {
    tagFilter(
      removeTagsList($(event.currentTarget)[0].getAttribute("data-selected"))
    );
  });

  const createTagsList = () => {
    tags = $(".tag.isSelected")
      .toArray()
      .map((elem) => {
        return elem.getAttribute("data-selected"); //data-selectedにはタグのIDが入っている
      })
      .filter((elem): elem is string => !!elem);
    return tags;
  };
  const removeTagsList = (clickedTag: string | null) => {
    return createTagsList().filter((tag) => tag !== clickedTag);
  };

  // タグフィルターとDOM生成を行う
  async function tagFilter(tags: string[]) {
    const data: TagFilterAPIResponse = await sendTags(tags);
    createCategoriesDOM(data.filtered_categories, data.tags, data.courses_num);
    urlAdapter(tags);
    // 全てのタグの選択を解除してから改めて付与する
    const allTags: JQuery<HTMLElement> = $(".tag");
    allTags.removeClass("isSelected");
    const targetTags: HTMLElement[] = allTags.toArray().filter((elem) => {
      const tag = elem.getAttribute("data-selected");
      return !!tag && tags.includes(tag);
    });
    $(targetTags).addClass("isSelected");
  }

  const urlAdapter = (tags: string[]) => {
    // 非同期処理に成功したらURLを変える
    if (tags.length !== 0) {
      const urlParams = "categories/tags=" + tags.join("&");
      history.replaceState("", "", "/" + urlParams);
    } else {
      history.replaceState("", "", "/categories");
    }
  };

  async function sendTags(tags: string[]) {
    return await fetch(
      "/api/v1/tags?tags[]=" + tags.map(encodeURIComponent).join("&tags[]="),
      {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
        redirect: "follow",
        referrer: "no-referrer",
      }
    )
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        throw new Error("network response was not ok");
      })
      .catch((err) => console.error(err));
  }

  const createCategoriesDOM = (
    filteredCategories: filteredCategory[],
    tags: tag[],
    coursesNum: string
  ) => {
    $(".categories-list").empty();
    $(".categories-list").append(
      filteredCategories.map((filteredCategory) => {
        const category = filteredCategory.category;
        const totalTime = filteredCategory.total_time;
        const result = $(
          `<li class="category" id="category_${category.id}">
            <div class="category__title--wrapper">
              <div class="category-left">
                <h2 class="category_name--large">${escape(category.name)}</h2>
                <div class="category__total-time">
                  <p class="c-text__extrasmall2--textgray">合計所要時間</p>
                  <span class="c-text__small--textgray">${formatMins(
                    totalTime
                  )}</span>
                  <p class="c-text__extrasmall2--textgray">min</p>
                </div>
                <div class="category--short-description c-text__small--black">${escape(
                  category.short_description
                )}
              </div>
              <p class="category__link--pc">
                <a href="/category/${category.id}">
                詳細を見る >
                </a>
              </p>
              <p class="category__link--sp">
                <a href="/category/${category.id}">詳細を見る</a>
              </p>
            </div>
          </li>`
        );
        result.append(
          $(`<ul class="filtered-courses-wrapper courses-list"></ul>`).append(
            filteredCategory.courses.map((course) => {
              return $(
                `<li class=" thumbnail course__card">
                  <a href="/courses/${escape(course.course.url_name)}">
                    <img alt="コース" width="400" height="300" class="course__thumbnail" src="${
                      course.course_image || "/assets/noImage.png"
                    }" />
                    <div class="course__title">
                      <h2 class="c-text__small2--black">${escape(
                        course.course.name
                      )}</h2>
                      <p class="c-text__extrasmall--black course__description">${escape(
                        course.course.simple_description
                      )}</p>
                    </div>
                    <div class="course__info">
                      <div class="course__lesson-count-wrapper">
                        <p class="c-text__extrasmall2--textgray course__subsection">
                          レッスン数
                        </p>
                        <div class="course__count">
                          <img src="/assets/play.png" alt="動画マーク" />
                          <div class="c-text__small--textgray course__lesson-count">
                            <span>${
                              filteredCategory.lessons_count[course.course.id]
                            }</span>
                            <p class="c-text__extrasmall--textgray">
                              回
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="course__needed-time-wrapper">
                        <p class="c-text__extrasmall--textgray course__subsection">
                          所要時間
                        </p>
                        <div class="course__count">
                          <img src="/assets/clock.png" alt="時計マーク" />
                          <div class="c-text__small--textgray course__needed-time">
                            <span>${formatMins(
                              course.course.needed_time
                            )}</span>
                            <p class="c-text__extrasmall--textgray">
                            min
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </li>`
              );
            })
          )
        );
        return result;
      })
    );
    createTagDOM(tags, coursesNum);
  };

  const createTagDOM = (tags: tag[], coursesNum: string) => {
    if (tags === null) return;
    $(".tagfilter-search__btn").prop("disabled", parseInt(coursesNum) === 0);
    $("#selected-tags-wrapper").empty();
    $(".filtered--courses__num--wrapper").empty();
    $(".filtered--courses__num--wrapper-sp").empty();
    if (tags.length !== 0) {
      $(".filtered--courses__num--wrapper").append(`
      <p class="filtered--courses__num c-text__small--black--bold">
        該当レッスン
      </p>
      <p class="filtered--courses__num c-text__small--primary--bold">
      ${coursesNum}
      </p>
      <p class="filtered--courses__num c-text__small--black--bold">
        件
      </p>`);
      $(".filtered--courses__num--wrapper-sp").append(
        `
      <p class="filtered--courses__num-sp c-text__small--black--bold">
        該当
      </p>
      <p class="filtered--courses__num-sp--secondary c-text__small--bold">
      ${coursesNum}
      </p>
      <p class="filtered--courses__num-sp c-text__small--black--bold">
          件
      </p>
      `
      );
      $(".new_movie_list").css("display", "none");

      $("#selected-tags-wrapper").append(
        tags.map((tag) => {
          return $(
            `<div class="current-tag" data-selected=${tag.id}>${escape(
              tag.name
            )}</div>`
          );
        })
      );
    } else {
      $(".new_movie_list").css("display", "block");
    }
  };
  // 検索ボタンクリック時
  $(".tagfilter-search__btn").click(() => {
    btnClickComponentControll();
  });
  // キャンセルボタンクリック時
  $(".tagfilter-cancel__btn").click(() => {
    tagFilter(oldTagsSnapShot);
    btnClickComponentControll();
  });
  const btnClickComponentControll = () => {
    $(".categories").fadeIn(fadeInOutDuration);
    $(".categories-filter").fadeOut(fadeInOutDuration);
    $(".search__circle--btn").fadeToggle(fadeInOutDuration);
    closeModalScrollControl();
  };

  // 検索アイコンクリック時
  $(".search__circle--btn").click((event) => {
    $("body, html").animate({ scrollTop: 0 }, 300, "linear");
    $(".categories-filter").fadeIn(fadeInOutDuration);
    $(event.currentTarget).fadeOut(fadeInOutDuration);
    openModalScrollControl();
    oldTagsSnapShot = createTagsList();
  });

  // モーダル表示中のスクロールを制御
  let scrollPos: any;
  const openModalScrollControl = () => {
    $("html, body").addClass("no-scroll");
    scrollPos = $(window).scrollTop();
  };
  const closeModalScrollControl = () => {
    $("html, body").removeClass("no-scroll");
    $(window).scrollTop(scrollPos);
  };

  // Window幅が替わった際の表示内容の不具合を調節
  $(window).resize(() => {
    const width = $(window).width();
    const breakpointTablet = 768;
    if (width && breakpointTablet <= width) {
      $(".tag").removeClass("isOpen");
      $(".categories").show();
      $(".categories-filter").show();
    }
    if (width && width < breakpointTablet) {
      $(".categories-filter").hide();
    }
  });

  $(".accordion--trigger").on("click", (event: any) => {
    const accordionDOM = $(event.currentTarget);
    accordionDOM.siblings(":nth-child(n + 4)").toggleClass("isOpen");
    accordionDOM
      .toggleClass("active")
      .text(accordionDOM.hasClass("active") ? "- 閉じる" : "+ 全て表示");
  });
});

function formatMins(s?: number) {
  return s ? Math.ceil(s / 60).toString() : "-";
}
